import React from "react";
import Header from "~components/Header";
import OldHeader from "~components/OldHeader";
import Footer from "~components/Footer";
import AppDownload from "~components/AppDownload";
import SSOLogin from "~components/Header/utils";
import { getCookie } from "~utils";
import { createRoot } from "react-dom/client";

const DEFAULT_OPTIONS = {
  header: null,
  footer: null,
  appDownload: null,
  forceLogin: false,
  locale: "zh_CN",
  analytics: false,
  onLogin: (user) => {},
  onSDKLogin: (user) => {},
  onSDKVisibilityChange: (flag) => {},
  onSDKInitialized: () => {},
  onLogout: () => {},
  env: null, //must
  disableSSO: false,
};

const SDK_DATA_SOURCES = {
  dev: "https://cdn-public-dev.nio.com",
  test: "https://cdn-public-test.nio.com",
  stg: "https://cdn-public-stg.nio.com",
  prod: "https://cdn-public.nio.com",
};

export default class AlpsNavigationSDK {
  constructor(options = {}) {
    this.options = {
      ...DEFAULT_OPTIONS,
      ...options,
    };

    this.ssoLogin = new SSOLogin(this.options);
    if (this.options.env === null) {
      console.error(
        "Parameter env is required under options for AlpsNavigationSDK"
      );
    }
    if (this.options.header && this.options.env !== null) {
      if (!window.AlpsNavigationSDKData) {
        if (document) {
          this.loadPageDataScript();
        }
      } else {
        this.renderHeader();
        this.renderFooter();
        this.renderAppDownload();
      }
    } else if (!this.options.disableSSO && this.options.env !== null) {
      this.ssoLogin.checkUserInfo();
    }
  }

  loadPageDataScript() {
    const script = document.createElement("script");
    script.src = `${
      SDK_DATA_SOURCES[this.options.env]
    }/www-alps-cn/cms/cdn-static/alps-navigation-sdk-data.js?${+Date.now()}`;
    script.async = true;
    script.onload = () => {
      this.options.pageData = window.AlpsNavigationSDKData;
      this.renderHeader();
      this.renderFooter();
      this.renderAppDownload();
    };
    document.head.appendChild(script);
  }

  renderHeader() {
    if (this.options.header) {
      if (this.options.env === "prod") {
        return createRoot(this.options.header).render(
          <OldHeader {...this.options} />
        );
      }
      return createRoot(this.options.header).render(
        <Header {...this.options} />
      );
    }
  }

  renderFooter() {
    if (this.options.footer)
      return createRoot(this.options.footer).render(
        <Footer {...this.options} />
      );
  }

  renderAppDownload() {
    if (this.options.appDownload)
      return createRoot(this.options.appDownload).render(
        <AppDownload {...this.options} />
      );
  }

  getHeaderHeight() {
    if (this.options.env === "prod") {
      return "64px";
    }
    if (window.matchMedia("(max-width: 719px)").matches) {
      return "48px";
    }
    return "56px";
  }

  login(customizedRedirectionUrl) {
    this.ssoLogin.handleExternalLogin(customizedRedirectionUrl);
  }

  getUserInfo() {
    const currentUserInfo = getCookie("alps-account-info");
    if (currentUserInfo) {
      return JSON.parse(currentUserInfo);
    } else {
      return null;
    }
  }

  redirectToHome() {
    if (this.options.pageData?.header?.homeLink) {
      window.location.href = this.options.pageData.header.homeLink;
    }
  }

  getVersions() {
    return VERSION;
  }
}
